;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { cn } from '@workspace/ui/lib';
import { Building2 } from 'lucide-react';

const avatarSizeClasses = {
  /** Figma popover trigger (38119:51494): 26px circle, 12px icon */
  trigger: { container: 'size-[26px]', icon: 'size-3' },
  sm: { container: 'size-6', icon: 'size-3' },
  md: { container: 'size-6', icon: 'size-3' },
} as const;

interface OrganisationSwitcherAvatarProps {
  size?: keyof typeof avatarSizeClasses;
  className?: string;
}

export function OrganisationSwitcherAvatar({
  size = 'md',
  className,
}: OrganisationSwitcherAvatarProps) {
  const { container, icon } = avatarSizeClasses[size];

  return (
    <div
      className={cn(
        'bg-grey-100 text-neutral-200 dark:bg-grey-900 dark:text-grey-400 flex shrink-0 items-center justify-center rounded-full',
        container,
        className
      )}
      aria-hidden
    >
      <Building2 className={cn(icon, 'shrink-0 stroke-[1.75]')} />
    </div>
  );
}
